import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const generatePDF = (mode: 'print' | 'download') => {
    const root = document.querySelector("#root");
    const printable = document.querySelector(".printable");
    if( printable) {
        printable!.appendChild(root!.cloneNode(true));
        const HTML_Width = printable.getBoundingClientRect().width;
        const HTML_Height = printable.getBoundingClientRect().height;
        const top_left_margin = 15;
        const PDF_Width = HTML_Width+(top_left_margin*2);
        const PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        const canvas_image_width = HTML_Width;
        const canvas_image_height = HTML_Height;

        const totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        html2canvas(printable as HTMLElement, {scale: 2}).then(canvas => {
            canvas.getContext('2d');
            const imgData = canvas.toDataURL("image/jpeg", 2.0);
            const pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
            pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            for (let i = 1; i <= totalPDFPages; i++) {
                pdf.addPage([PDF_Width, PDF_Height]);
                pdf.addImage(imgData, 'JPG', top_left_margin, -(PDF_Height*i)+(top_left_margin*4),canvas_image_width,canvas_image_height);
            }

            if(mode === 'download') {
                pdf.save("download.pdf");
            } else {
                pdf.autoPrint();
                pdf.output('dataurlnewwindow');
            }
            printable.innerHTML = '';
        });
    }
}
